import type { HeatmapBlock } from '../types/report'
import styles from './blocks.module.css'

// Map a normalized value (0..1) to a blue→red scale via hue rotation
// (220° blue → 0° red). This is a data scale, not a brand color.
function colorFor(t: number): string {
  const clamped = Math.max(0, Math.min(1, t))
  const hue = 220 - 220 * clamped
  return `hsl(${hue}, 75%, 45%)`
}

export function Heatmap({ block }: { block: HeatmapBlock }) {
  const flat = block.values.flat()
  const min = flat.length ? Math.min(...flat) : 0
  const max = flat.length ? Math.max(...flat) : 1
  const span = max - min || 1
  const cols = block.x_labels.length

  return (
    <div className={styles.block}>
      {block.title ? <div className={styles.blockTitle}>{block.title}</div> : null}
      <div className={styles.heatmapScroll}>
        <div
          className={styles.heatmapGrid}
          style={{ gridTemplateColumns: `auto repeat(${cols}, 1fr)` }}
        >
          <div className={styles.heatmapCorner} />
          {block.x_labels.map((x) => (
            <div className={styles.heatmapXHead} key={x}>
              {x}
            </div>
          ))}
          {block.y_labels.map((y, ri) => (
            <Row key={y} label={y} row={block.values[ri] ?? []} min={min} span={span} />
          ))}
        </div>
      </div>
      <div className={styles.heatmapLegend}>
        <span>niedrig</span>
        <span className={styles.heatmapLegendBar} />
        <span>hoch{block.unit ? ` (${block.unit})` : ''}</span>
      </div>
    </div>
  )
}

function Row({ label, row, min, span }: { label: string; row: number[]; min: number; span: number }) {
  return (
    <>
      <div className={styles.heatmapYHead}>{label}</div>
      {row.map((v, ci) => (
        <div
          className={styles.heatmapCell}
          key={ci}
          style={{ background: colorFor((v - min) / span) }}
          title={String(v)}
        >
          {v}
        </div>
      ))}
    </>
  )
}
